export const MAIN_BENEFITS_TEST_IDS = {
  // ─── Benefits Section ───
  sectionContainer: 'main-benefits-section-container',

  // ─── Benefit Card (dynamic per item) ───
  benefitCard: (index: number) => `main-benefits-card-${index}`,
  benefitCardIcon: (index: number) => `main-benefits-card-icon-${index}`,
  benefitCardTitle: (index: number) => `main-benefits-card-title-${index}`,
} as const;
